module.exports = __webpack_public_path__ + "static/media/AppleMusic.2aae063f.svg";